import ApiRequest from "../index"

const treatmentRequest = {
  getTreatments: async () => ApiRequest.get("/v2/lojinha/complements/treatment"),
  putTreatment: async data =>
    ApiRequest.put("/v2/lojinha/complements/treatment", { ...data })
}

export default treatmentRequest
